// src/components/managesubs/ManagePricingSection.js
import React, { useState } from "react";
import PricingCard from "../PricingCard";
import { Check } from "lucide-react";
import { PlanName } from "../../enums/prices";
import { useAuth } from "../../context/Authcontext";
import { PlanType } from "../../enums/prices";

const ManagePricingSection = ({ currentPlan }) => {
  // Define pricing cards data
  const { isAuthenticated } = useAuth();
  // console.log(currentPlan);
  const [billingPeriod, setBillingPeriod] = useState("monthly");

  const pricingCards = [
    //{
    //  title: "Free Trial Plan",
    //  monthlyPrice : "Free",
    //  yearlyPrice : "Free",
    //  period: "",
    //  description: "",
    //  features: [
    //    "100 on market leads",
    //    "Single family properties",
    //    "Mortgage information",
    //    "Owner information", 
    //    "Agent information"],  
    //  isFeatured: false,
    //  buttonText: "Get Started",
    //  plantype: PlanType.FREE,
    //
    //},
    // {
    //   title: "Basic Plan",
    //   monthlyPrice: "$59",
    //   yearlyPrice: "$497",
    //   period: "/month",
    //   description: "",
    //   features: [
    //     "5,000 on market leads",
    //     "Single family properties",
    //     "Mortgage information",
    //     "Owner information",
    //     "Agent information"],
    //   isFeatured: false,
    //   buttonText: "Get Started",
    //   plantype: PlanType.BASIC,
    // },
    // {
    //   title: "Advanced Plan",
    //   monthlyPrice: "$119",
    //   yearlyPrice: "$797",
    //   period: "/month",
    //   description: "",
    //   features: ["10,000 Credit", "All types of properties", "Keyword filters", "Owner information", "Agent information"],
    //   isFeatured: false,
    //   buttonText: "Get Started",
    //   plantype: PlanType.ADVACED,
    // },
    // {
    //   title: "Entreprise Plan",
    //   price: "$169",
    //   monthlyPrice: "$169",
    //   yearlyPrice: "$1,297",
    //   period: "/month",
    //   description: "",
    //   features: ["20,000 Credit", "All types of properties", "Keyword filters", "Owner information", "Agent information"],
    //   isFeatured: true,
    //   buttonText: "Get Started",
    //   plantype: PlanType.ENTREPRISE,
    // },
      {
      title: "Openning Plan",
      price: "$497",
      monthlyPrice: "$497",
      yearlyPrice: "$497",
      period: "/Lifetime",
      description: "",
      features: ["20,000 Credit", "All types of properties", "Keyword filters", "Owner information", "Agent information"],
      isFeatured: true,
      buttonText: "Get Started",
      plantype: PlanType.ONETIMEDEAL,
    },
    
  ];
  // Logic to determine which cards to show based on current plan
  const getDisplayedCards = () => {

    return pricingCards.map(card => ({
      ...card,
      isCurrent: card.plantype === currentPlan
    }));

  };
  const toggleBillingPeriod = () => {
    setBillingPeriod(prev => (prev === "Monthly" ? "Yearly" : "Monthly"));
  };
  const displayedCards = getDisplayedCards();

  // Render pricing section only if there are cards to display
  if (displayedCards.length === 0) {
    return null;
  }

  // Check if user is authenticated
  if (!isAuthenticated) {
    return (
      <section id="pricing" className="py-12 pb-0 bg-transparent">
        <div className="min-h-screen bg-gray-100 flex flex-col items-center p-4">
          <div className="relative  w-full max-w-[95vw] bg-white rounded-lg shadow-lg p-4">
            {/* <button
              onClick={toggleBillingPeriod}
              className="absolute top-8 right-8 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 hover:scale-105 transition-transform"
            >
              {billingPeriod === "Monthly" ? "Monthly" : "Yearly"}
            </button> */}
            <div className="text-center mb-12">
              <h1 className="text-4xl font-bold text-gray-900 mb-4 leading-tight">
                Choose The Plan That Fits<br />
                Your Needs :
              </h1>
            </div>
            <div className="text-center py-12">
              <p className="text-lg text-gray-600 mb-4">
                Please log in to view and upgrade your subscription plans.
              </p>
              <a
                href="/login"
                className="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
              >
                Log In
              </a>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="pricing" className="py-12 pb-0 bg-transparent">
      <div className="min-h-screen bg-gray-100 flex flex-col items-center p-4">
        <div className="relative  w-full max-w-[95vw] bg-white rounded-lg shadow-lg p-4">
          {/* <button
            onClick={toggleBillingPeriod}
            className="absolute top-8 right-8 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 hover:scale-105 transition-transform"
          >
            {billingPeriod === "Monthly" ? "Monthly" : "Yearly"}
          </button> */}

          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4 leading-tight">
              Choose The Plan That Fits<br />
              Your Needs :
            </h1>
          </div>
          <div className="flex justify-center mb-12">
            <div className="max-w-6xl w-full">
              <div
                className={`grid gap-6 mx-auto ${displayedCards.length === 1 ? "grid-cols-1 max-w-md" :
                  displayedCards.length === 2 ? "grid-cols-2 max-w-4xl" : "grid-cols-3"
                  } ${currentPlan === PlanName.free ? "ml-52" : ""}`}
              >
                {displayedCards.map((card, index) => (
                  <PricingCard
                    key={index}
                    title={card.title}
                    price={billingPeriod === "Monthly" ? card.monthlyPrice : card.yearlyPrice}
                    period={
                      card.title === "Openning Plan"
                        ? "/Lifetime"      // always fixed for Free Trial
                        : billingPeriod === "Monthly"
                          ? "/month"
                          : "/year"
                    }
                    description={card.description}
                    features={card.features}
                    isFeatured={card.isFeatured}
                    buttonText={card.buttonText}
                    isCurrent={card.isCurrent}
                    plantype={card.plantype}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="text-center mt-8">
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">All Plans Include</h3>
            <ul className="text-gray-600 text-base space-y-2 text-center mx-auto max-w-md">
              <li className="flex items-center justify-center">
                <Check className="w-5 h-5 text-blue-600 mr-2" />
                Access to comprehensive U.S. real estate datasets
              </li>
              <li className="flex items-center justify-center">
                <Check className="w-5 h-5 text-blue-600 mr-2" />
                Customizable data filters and reports
              </li>
              <li className="flex items-center justify-center">
                <Check className="w-5 h-5 text-blue-600 mr-2" />
                Intuitive platform for data analysis
              </li>
              <li className="flex items-center justify-center">
                <Check className="w-5 h-5 text-blue-600 mr-2" />
                No advanced data skills required
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ManagePricingSection;